/**
 * Algolia config for venue search and write.
 * Values come from runtime Firestore config/publicEnv when available (see runtimeEnv.js),
 * else from .env (REACT_APP_ALGOLIA_*). Write key is never in Firestore; use .env only.
 * Index name is fixed to "venues" across the app.
 */
import { getPublicConfig } from './runtimeEnv';

function fromRuntimeOrEnv(runtimeKey, envKey) {
  const c = getPublicConfig();
  return (c[runtimeKey] || process.env[envKey] || '').trim();
}

/** Read at use-time so runtime Firestore config is used after fetchPublicEnv(). */
export function getAlgoliaAppId() {
  return fromRuntimeOrEnv('REACT_APP_ALGOLIA_APP_ID', 'REACT_APP_ALGOLIA_APP_ID');
}
export function getAlgoliaSearchKey() {
  return fromRuntimeOrEnv('REACT_APP_ALGOLIA_SEARCH_KEY', 'REACT_APP_ALGOLIA_SEARCH_KEY');
}
/** Write key is never in Firestore; use process.env only (or decrypt script for .env). */
export function getAlgoliaWriteApiKey() {
  return (process.env.REACT_APP_ALGOLIA_WRITE_API_KEY || '').trim();
}

/** Algolia index for venues — use "venues" only. */
export const ALGOLIA_VENUE_INDEX = 'venues';

/** Algolia index for GradedPlay search/show: user IDs, group memberships, group IDs (synced from Firebase). */
export const ALGOLIA_USERS_INDEX = 'users';

/** True when search is available (app id + search key + index). */
export function isAlgoliaConfigured() {
  return !!(getAlgoliaAppId() && getAlgoliaSearchKey() && ALGOLIA_VENUE_INDEX);
}

/** True when write/index/delete is available (app id + write key + index). */
export function isAlgoliaWriteConfigured() {
  return !!(getAlgoliaAppId() && getAlgoliaWriteApiKey() && ALGOLIA_VENUE_INDEX);
}
